import { useQuery } from 'react-query'

import { QUERY_KEYS } from 'src/constants'
import { quantityTypeCategoryService } from 'src/services/quantity-type-category.service'

export const useQuantityTypeCategoryChanges = (id: string) => {
  return useQuery([QUERY_KEYS.QUANTITY_TYPE_CATEGORY_CHANGES, id], () =>
    quantityTypeCategoryService.getCategoryChanges(id),
  )
}
